import { AsyncStateNotification } from '@ui/notifications';
import { COPY_GENERIC } from '@sonar-software/sonar-ts-constants';
import { coreActions } from '@sonar-software/sonar-core';
import { createSonarSelector } from '@lib/selectors';
import React from 'react';
const hideSelector = createSonarSelector((state) => state.core.dataSecurity.applications.hide);
export const HideAppNotifications = () => React.createElement(AsyncStateNotification, { errored: COPY_GENERIC.CONTACT_SUPPORT, failed: COPY_GENERIC.CONTACT_SUPPORT, resetRawAction: coreActions.resetDeleteCoreDataSecurityApplications, stateSelector: hideSelector });
